import React from 'react';
import { useNavigate } from 'react-router-dom';

const styles = {
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '16px',
    marginBottom: '12px',
    boxShadow: '0 2px 12px rgba(240,90,53,0.1)',
    cursor: 'pointer',
    transition: 'transform 0.1s ease',
    border: 'none',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '6px',
  },
  title: {
    fontSize: '16px',
    fontWeight: '600',
    color: 'var(--tg-theme-text-color, #000)',
    flex: 1,
  },
  badge: {
    backgroundColor: 'var(--tg-theme-button-color, #007aff)',
    color: 'var(--tg-theme-button-text-color, #fff)',
    borderRadius: '10px',
    padding: '2px 8px',
    fontSize: '12px',
    fontWeight: '600',
    marginLeft: '8px',
  },
  description: {
    fontSize: '13px',
    color: 'var(--tg-theme-hint-color, #8e8e93)',
    marginBottom: '8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '12px',
    color: 'var(--tg-theme-hint-color, #8e8e93)',
  },
  tag: {
    backgroundColor: 'transparent',
    borderRadius: '6px',
    padding: '2px 6px',
    fontSize: '11px',
  },
};

export default function ListCard({ list, onDelete }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/lists/${list.id}`);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    if (onDelete && window.confirm(`Удалить "${list.title}"?`)) {
      onDelete(list.id);
    }
  };

  const itemCount = list.item_count || 0;
  const isOwner = list.my_role === 'admin' || !list.my_role;

  return (
    <div style={styles.card} onClick={handleClick}>
      <div style={styles.header}>
        <span style={styles.title}>{list.title}</span>
        {itemCount > 0 && <span style={styles.badge}>{itemCount}</span>}
      </div>

      {list.description && (
        <p style={styles.description}>{list.description}</p>
      )}

      <div style={styles.meta}>
        <span style={styles.tag}>{list.is_personal ? '🔒 Личный' : '👥 Общий'}</span>
        {list.my_role && !isOwner && (
          <span style={styles.tag}>{list.my_role === 'edit' ? 'редактировать' : list.my_role === 'view' ? 'смотреть' : list.my_role}</span>
        )}
        <span>{new Date(list.created_at).toLocaleDateString()}</span>
        {isOwner && onDelete && (
          <button
            onClick={handleDeleteClick}
            style={{
              marginLeft: 'auto',
              background: 'none',
              border: 'none',
              color: '#ff3b30',
              cursor: 'pointer',
              fontSize: '13px',
            }}
          >
            Удалить
          </button>
        )}
      </div>
    </div>
  );
}
